<template lang="pug">
grid-container.primary(
  v-if="about.text",
  cols="auto",
  cols-md="repeat(2, calc(50% - 8px))"
)
  div
    template(v-if="about.video_file")
      .position-relative.item-video-content
        .d-flex.align-center.justify-center.item-video-mask(v-if="!isPlaying")
          v-icon(color="#ffffff", :size="mobile ? '40px' : '50px'") fa-play-circle

        video(
          @click="(e) => playVideo(e)",
          ref="video",
          width="100%",
          height="100%",
          :controls="isPlaying",
          :src="files + about.video_file"
        )
    template(v-else)
      iframe.mb-n1(
        v-responsive="mdOnly ? 1 : 16/9",
        :src="`https://www.youtube.com/embed/${getYoutubeCode(about.video)}`",
        width="100%",
        height="100%",
        frameborder="0",
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowfullscreen
      )
  .pa-10.white--text.d-flex.justify-center.align-center
    div
      custom-title.mb-2(type="large", simple, white) Sobre Nós
      .text-body-1(v-html="about.text")
</template>

<script>
import CustomTitle from "@/components/others/CustomTitle";
import { getYoutubeCode } from "@/components/utils.js";

export default {
  data: () => ({
    isPlaying: false,
  }),
  computed: {
    about() {
      return this.$rest("about").item;
    },
    mdOnly() {
      return this.$vuetify.breakpoint.mdOnly;
    },
  },
  beforeCreate() {
    this.$rest("about").get({
      save: (state, data) => (state.item = data),
    });
  },
  methods: {
    getYoutubeCode,
    playVideo(e) {
      const video = e.target;

      if (video.paused) {
        video.play();

        setTimeout(() => {
          this.isPlaying = true;
        }, 100);
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },
  },
  components: {
    CustomTitle,
  },
};
</script>

<style scoped>
.item-video-content {
  cursor: pointer;
  position: relative;
}

.item-video-mask {
  bottom: 0;
  left: 0;
  opacity: 0.7;
  position: absolute;
  right: 0;
  top: 0;
  transition: all 0.1s linear;
}

.item-video-content:hover .item-video-mask {
  opacity: 1;
}
</style>
